import styled, { Device, Modal, Scale, Typography, breakpoints } from '@secretescapes/falcon';

export const StyledModal = styled(Modal)`
  > div {
    width: 100%;
    max-width: 576px;

    @media (max-width: ${breakpoints[Device.tablet]}) {
      max-height: 483px;
    }

    overflow: auto;
    height: fit-content;
    margin: auto;
    padding: ${Scale.xxl};
    max-height: 95%;
  }
`;

export const StyledModalHeader = styled(Typography)`
  padding-bottom: ${Scale.m};
`;
